import OrcamentoMail from './OrcamentoMail';

export default OrcamentoMail;
